import { render, staticRenderFns } from "./ManualReportingBox.vue?vue&type=template&id=1a64e43b&scoped=true&"
import script from "./ManualReportingBox.vue?vue&type=script&lang=js&"
export * from "./ManualReportingBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a64e43b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a64e43b')) {
      api.createRecord('1a64e43b', component.options)
    } else {
      api.reload('1a64e43b', component.options)
    }
    module.hot.accept("./ManualReportingBox.vue?vue&type=template&id=1a64e43b&scoped=true&", function () {
      api.rerender('1a64e43b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/reportoutage/ManualReportingBox.vue"
export default component.exports